var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-radio',{key:_vm.text,staticClass:"mx-1 mcq-proposal",attrs:{"value":_vm.value,"size":"lg"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }